import { csrfToken } from "./orderActions"

// Footprints: a guest's start is held out of the counts until the page shows
// a person (OpenHouse::FootprintTrail#unconfirmed_guest). Crawlers posing as
// browsers load a page and leave; a person stays or touches it. When the
// layout names the report path, report once after 10 seconds with the page
// visible, or at the first real input. Programmatic scroll is not input.
const INPUTS = ["pointerdown", "keydown", "touchstart", "wheel"]
export const DWELL_MS = 10_000
const TICK_MS = 1_000
const MAX_ATTEMPTS = 3

export function watchPresence(doc = globalThis.document, win = globalThis.window) {
  const path = doc?.querySelector('meta[name="tuw-footprint-presence"]')?.getAttribute("content")
  if (!path) return

  let done = false
  let inFlight = false
  let attempts = 0
  let visibleMs = 0
  let timer = null

  const finish = () => {
    done = true
    clearInterval(timer)
    INPUTS.forEach((type) => win.removeEventListener(type, report, true))
  }

  // Watching stops only once the report lands; a failed one (offline, or the
  // endpoint's rate limit) tries again at the next input or after another
  // dwell, up to MAX_ATTEMPTS.
  function report() {
    if (done || inFlight) return
    inFlight = true
    attempts += 1

    fetch(path, {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: { Accept: "application/json", "X-CSRF-Token": csrfToken() },
    })
      .then((response) => {
        if (response.ok) finish()
      })
      .catch(() => {})
      .finally(() => {
        inFlight = false
        visibleMs = 0
        if (!done && attempts >= MAX_ATTEMPTS) finish()
      })
  }

  INPUTS.forEach((type) => win.addEventListener(type, report, { capture: true, passive: true }))

  timer = setInterval(() => {
    if (doc.visibilityState !== "visible") return

    visibleMs += TICK_MS
    if (visibleMs >= DWELL_MS) report()
  }, TICK_MS)
}
